import React, { useState } from 'react'; 
import './Active.css';
import { useDispatch, useSelector } from 'react-redux';
import { userActivities } from '../../../store/api'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

export const Active = (props) => {
  const dispatch = useDispatch()
  const {activity, userData} = useSelector(state => state.currentUser) 
  const [userId, setUserId] = useState(props.id);  
   

  React.useEffect(()=>( 
    dispatch(userActivities(userId))
 
  ),[userId])
  // Преобразование данных для графика
  const transformDataForChart = (activity) => {
    const timeSeries = {};
    
    activity.forEach(activity => {
      const date = new Date(activity.time).toLocaleDateString('ru-RU');
      if (!timeSeries[date]) {
        timeSeries[date] = {
          date,
          login: 0,
          visit: 0,
          dfoodlist: 0,
          dplan: 0,
          upmanual: 0,
          copyPlan: 0,
          drecipe: 0,
          uprecipe: 0,
          createmanual: 0,
          addmeals: 0,
          foodlist: 0,
          gener: 0,
          settings: 0,
          upplan: 0,
          reset: 0
        };
      }
      timeSeries[date][activity.actionType]++;
    });
    
    return Object.values(timeSeries);
  };

  const chartData = transformDataForChart(activity);

 



  return (
    <div className="activity-chart-container">
      <h2>Анализ активностей пользователя</h2>
      
      {/* Поисковая строка
      <form className="search-form">
        <div className="search-input-group">
          <input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="Введите ID пользователя"
            className="search-input"
          />
          <button 
            type="submit" 
            disabled={statusActive  === 'loading'}
            className="search-button"
          >
            {statusActive === 'loading' ? 'Загрузка...' : 'Поиск'}
          </button>
        </div>
      </form>

      {errorActive && <div className="error-message">{errorActive}</div>}
 */}
      {/* График */}
      {activity.length > 0 && (
        <div className="chart-section">
          <h3>Активности пользователя: {userId} </h3>
          <div className='font20Norm'>{`Имя: ${userData.name}, email: ${userData.email},  Подписка: ${userData.subscription.title} `}</div>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={400}>
              <LineChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                
                {/* Линии для каждого типа активности */}
                <Line 
                  type="monotone" 
                  dataKey="login" 
                  stroke="#8884d8" 
                  strokeWidth={2}
                  name="Логин"
                />
                <Line 
                  type="monotone" 
                  dataKey="visit" 
                  stroke="#82ca9d" 
                  strokeWidth={2}
                  name="Посещение"
                />
                <Line 
                  type="monotone" 
                  dataKey="dfoodlist" 
                  stroke="#ffc658" 
                  strokeWidth={2}
                  name="Удаление СП"
                />
                <Line 
                  type="monotone" 
                  dataKey="dplan" 
                  stroke="#ff7300" 
                  strokeWidth={2}
                  name="Удаление плана"
                />
                <Line 
                  type="monotone" 
                  dataKey="foodlist" 
                  stroke="#0088fe" 
                  strokeWidth={2}
                  name="редакт СП"
                />
                <Line 
                  type="monotone" 
                  dataKey="gener" 
                  stroke="#00C49F" 
                  strokeWidth={2}
                  name="Генерация"
                />
                <Line 
                  type="monotone" 
                  dataKey="settings" 
                  stroke="#FFBB28" 
                  strokeWidth={2}
                  name="Настройки"
                />
                <Line 
                  type="monotone" 
                  dataKey="upplan" 
                  stroke="#FF8042" 
                  strokeWidth={2}
                  name="Обновление плана"
                />
                 <Line 
                  type="monotone" 
                  dataKey="copyPlan" 
                  stroke="#5041b4ff" 
                  strokeWidth={2}
                  name="Копирование"
                />
                 <Line 
                  type="monotone" 
                  dataKey="upmanual" 
                  stroke="#77b125ff" 
                  strokeWidth={2}
                  name="Ручная замена"
                />
                 <Line 
                  type="monotone" 
                  dataKey="createmanual" 
                  stroke="#cb3476ff" 
                  strokeWidth={2}
                  name="Ручная генерация"
                />
                 <Line 
                  type="monotone" 
                  dataKey="drecipe" 
                  stroke="#ba8a8aff" 
                  strokeWidth={2}
                  name="удаление рецепта"
                />
                 <Line 
                  type="monotone" 
                  dataKey="uprecipe" 
                  stroke="#5a6e3dff" 
                  strokeWidth={2}
                  name="автозамена рецепта"
                />
                 <Line 
                  type="monotone" 
                  dataKey="addmeals" 
                  stroke="#cb3476ff" 
                  strokeWidth={2}
                  name="Добавл приема пищи"
                />
                <Line 
                  type="monotone" 
                  dataKey="reset" 
                  stroke="#888888" 
                  strokeWidth={2}
                  name="Сброс"
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {/* Таблица с детальными данными */}
      {activity.length > 0 && (
        <div className="activities-table">
          <h4>Детальная история активностей</h4>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Тип активности</th>
                  <th>Время</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody>
                {activity.map((activity, index) => (
                  <tr key={index}>
                    <td>
                      <span className={`activity-badge ${activity.actionType}`}>
                        {activity.actionType}
                      </span>
                    </td>
                    <td>
                      {new Date(activity.time).toLocaleTimeString('ru-RU')}
                    </td>
                    <td>
                      {new Date(activity.time).toLocaleDateString('ru-RU')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};